import type { NavigationTarget } from "@kestrel/navigator";
import { base, baseUrl } from "@kestrel/path";
import type { Refresher, KestrelStores } from "@kestrel/stores";
import { slashWrapEnd, webJoin } from "@otto-ec/assets-core-utils/url";
import { get } from "svelte/store";
import type { Context } from "hono";
import type { HonoContext } from "../context/context.types";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const dataJsonKey = "__data";

/**
 *
 *
 *
 *
 *
 */
export const dataJsonValue = "json";

/**
 *
 *
 *
 */
export const isDataRequest = (c: Context<HonoContext>): boolean =>
  c.var[dataJsonKey] === dataJsonValue;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const navigationTarget = (
  routeId: string | null,
  routePath: string,
  extraBase: string = "",
  origin = location.origin,
): NavigationTarget => {
  const url = new URL(routePath, origin);
  const routeBase = baseUrl(extraBase).pathname;

  const res = {
    url,
    routeId,
    get routeBase() {
      return routeBase;
    },
    get query() {
      return url.searchParams;
    },
    set query(value) {
      url.search = value.toString();
    },
    get routePath() {
      return url.pathname.slice(routeBase.length);
    },
    set routePath(value: string) {
      if (slashWrapEnd(value).startsWith(routeBase)) {
        res.url.pathname = value;
      } else {
        res.url.pathname = webJoin(routeBase, value).pathname;
      }
    },
  };

  return res;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const defaultUpdateUrl = (
  to: NavigationTarget,
  url: string | URL | undefined,
): NavigationTarget => {
  if (!url) return to;

  const u = new URL(url, "http:/*     */
  to.url.hash = u.hash;
  to.url.search = u.search;
  to.routePath = u.pathname;

  return to;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const getNavigationTargetFromUrl = async (
  stores: KestrelStores,
  urlOrUpdate: Parameters<Refresher>[0],
  extraBase: string = "",
): Promise<NavigationTarget> => {
  /*                                                                                          */
  const to = navigationTarget(null, get(stores.routePath), extraBase);

  if (typeof urlOrUpdate === "function") return (await urlOrUpdate(to)) ?? to;
  if (urlOrUpdate) return defaultUpdateUrl(to, urlOrUpdate);

  return to;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const notStartsWithBase = (url: URL): boolean => !url.pathname.startsWith(base);
